import { AddressParseJobDto } from "types/api/addressParseJobs";
import { InboundShipmentParseJobDto } from "types/api/inboundShipmentParseJobs";
import { InvoiceParseJobDto } from "types/api/invoiceParseJobs";
import { http, RequestOptions, UPLOAD_REQUEST_OPTIONS } from "./transport";

// One job resource per agent workflow (docs/AGENT_JOBS.md): POST creates it
// and answers 202 with the job, GET reports it. The GET options carry the
// poll's abort signal and its remaining budget (utils/agentJob.ts).

export type JobRequestOptions = Pick<RequestOptions, "signal" | "timeout">;

const jobs = <TJob, TBody>(path: string, createOptions?: RequestOptions) => ({
  create: (body: TBody): Promise<TJob> =>
    http.post<TJob>(path, body, createOptions),
  get: (id: number, options?: JobRequestOptions): Promise<TJob> =>
    http.get<TJob>(`${path}/${id}`, options),
});

// Always multipart: raw_input and/or image, both top-level (backend spec).
export const addressParseJobs = jobs<AddressParseJobDto, FormData>(
  "/address_parse_jobs",
  UPLOAD_REQUEST_OPTIONS,
);

export const inboundShipmentParseJobs = jobs<
  InboundShipmentParseJobDto,
  { raw_input: string; inbound_address_id: number }
>("/inbound_shipment_parse_jobs");

export const invoiceParseJobs = jobs<InvoiceParseJobDto, FormData>(
  "/invoice_parse_jobs",
);
